import { appRoute } from "routes/app/home.runtime"
import { makeLazy } from "lib/make-lazy"

export const PlanReview = makeLazy(() => import("./plan-review"), "PlanReview")
appRoute.register("review/:planId", <PlanReview />)

export const PlanOverview = makeLazy(() => import("./plan-overview"), "PlanOverview")
appRoute.register("overview/:planId", <PlanOverview />)
